<template>
    <v-layout>
        <v-flex xs12>
            <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
            <v-card v-if="!loading" >
                <v-card-title class="headline primary white--text">
                    {{ 'Equipment Health Report'|translate }}
                    <v-spacer></v-spacer>
                    <date-range-selector class="white--text" v-model="dateRange"  @change="refresh()"></date-range-selector>
                    <v-btn class="white--text noprint"
                           flat
                           @click="exportAll()"
                    >
                        <v-icon class="mr-2">fa-print</v-icon>
                        {{'Print'|translate}}
                    </v-btn>
                </v-card-title>
                <v-card-text class="carnot-health-report-holder">
                    <v-layout row wrap>
                    <v-flex xs6>
                        <vue-echart v-if="ecOption&&items.length>0" :config="ecOption" :height="1000"></vue-echart>
                    </v-flex>
                    <v-flex xs6>
                        <vue-echart v-if="ecOption2&&items.length>0" :config="ecOption2" :height="1000"></vue-echart>
                    </v-flex>
                    <v-flex xs12>
                        <v-data-table
                            :headers="headers"
                            disable-initial-sort
                            :items="items"
                            class="elevation-1"
                            hide-actions
                        >
                            <template v-slot:items="props">
                                <td class="text-xs-left" >{{ props.item.floor }}</td>
                                <td class="text-xs-left">{{ props.item.equip }}</td>
                                <td class="text-xs-left" >{{ props.item.equipType }}</td>
                                <td class="text-xs-left">{{ props.item.title }}</td>
                                <td class="text-xs-left" >{{ props.item.value }}</td>
                                <td class="text-xs-left">
                                    <severity-chip :value="props.item.severity"></severity-chip>
                                </td>
                                <td class="text-xs-left" >{{ props.item.accumulated_cost }}</td>
                                <td class="text-xs-center">
                                    <template>
                                        <template v-if="!props.item.acknowledged">
                                            <v-icon color="warning" >fa-bell</v-icon>
                                        </template>
                                        <template v-else>
                                            <v-icon style="color:lightgrey" >fa-bell-slash</v-icon>
                                        </template>
                                    </template>
                                    <v-tooltip bottom v-if="props.item.maintenance_records&&props.item.maintenance_records.length>0">
                                        <template v-slot:activator="{ on }">
                                            <v-badge
                                                color="accent"
                                                overlap
                                            >
                                                <template v-slot:badge v-if="props.item.maintenance_records.filter(x=>!x.is_fixed).length>0">
                                                    <span>{{props.item.maintenance_records.length}}</span>
                                                </template>
                                                <v-icon v-on="on" small class="ml-2 mr-1" >fa-clipboard-list</v-icon>
                                            </v-badge>
                                        </template>
                                        <span>{{props.item.maintenance_records.length}} {{'Maintenance Records'|translate}} </span>
                                    </v-tooltip>
                                    <v-tooltip bottom v-if="props.item.maintenance_records&&props.item.maintenance_records.length>0&&props.item.maintenance_records.filter(x=>!x.is_fixed).length===0">
                                        <template v-slot:activator="{ on }">
                                            <v-badge
                                                color="accent"
                                                overlap
                                            >
                                                <v-icon v-on="on" color="success" class="ml-1">fa-check</v-icon>
                                            </v-badge>
                                        </template>
                                        <span>{{'Maintenance Completed'|translate}} </span>
                                    </v-tooltip>
                                </td>
                                <td class="text-xs-center">
                                    <ul v-if="props.item.maintenance_records&&props.item.maintenance_records.length>0">
                                        <li v-for="maintenance in props.item.maintenance_records">{{maintenance.maintenance_label}} <v-icon color="success" class="ml-1" v-if="maintenance.is_fixed">fa-check</v-icon></li>
                                    </ul>
                                </td>
                            </template>
                            <template v-slot:no-data>
                            </template>
                        </v-data-table>
                    </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import {getNotification, getMaintenanceRecords} from '../helper';
import moment from "moment";
import VueEchart from "@/components/VueEchart";
import {sortFloors} from '@/helper'
import SeverityChip from "@/components/SeverityChip";
import printer from "../components/mixins/printer";
import DateRangeSelector from "@/components/DateRangeSelector";

export default {
    name: 'EquipmentHealthReport',
    components: { VueEchart, SeverityChip,DateRangeSelector},
    mixins:[printer],
    data() {
        return {
            dialog: false,
            selectedEquipment: null,
            loading:true,
            config: [],
            dateRange: {
                start:moment().subtract(30, "days").format('YYYY-MM-DD HH:mm:ss'),
                end: moment().format('YYYY-MM-DD HH:mm:ss')
            },
            ecOption:null,
            ecOption2:null,
            items:[],
        }
    },
    mounted() {
        this.initialize()
    },
    computed: {
        headers() {
            return [
                {text: this.$options.filters.translate('Floor'), value: 'floor',sortable: true},
                {text: this.$options.filters.translate('Equipment'), value: 'equip'},
                {text: this.$options.filters.translate('Equipment Type'), value: 'equipType',sortable: true},
                {
                    text: this.$options.filters.translate('Issue'),
                    align: 'left',
                    sortable: true,
                    value: 'title'
                },
                {text: this.$options.filters.translate('Value'), value: 'value'},
                {text: this.$options.filters.translate('Severity'), value: 'severity'},
                {text: this.$options.filters.translate('Cost'), value: 'accumulated_cost'},
                {text: this.$options.filters.translate('Acknowledged'), value: 'acknowledged'},
                {text: this.$options.filters.translate('Maintenance records'), value: 'maintenance_records',sortable: false},
            ]
        },
    },
    methods: {
        async exportAll(){
            let title = this.$store.state.pointsListStore.pointsList.facility_name + "=Equipment_Health_Report"+ "="+this.dateRange.end
            await this.printPage('.carnot-health-report-holder', title)
        },
        initialize() {
            this.refresh()
        },

        async doRefresh() {
            this.loading=true
            this.ecOption=null
            this.ecOption2=null
            let rawMRs= await  getMaintenanceRecords({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                date_range:this.dateRange
            })
            let notifsResult = await getNotification({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                ignore_acknowledged:true,
                date_range:[this.dateRange.start,this.dateRange.end],
            })
            let filteredNotifs=notifsResult.result.filter(function(x) {
                return (x.topic==="equipment health")&&(x.severity.toLowerCase()==="critical"||x.severity.toLowerCase()==="high"||x.severity.toLowerCase()==="medium"||x.severity.toLowerCase()==="low") })
            let items = []
            for (let notif of filteredNotifs) {
                items.push({
                    icon: 'fa-bell',
                    alertType: notif['model'],
                    title: notif['title'],
                    equip: notif['equipment_name'],
                    equipType: notif['equipment_type'],
                    floor: notif['floor'],
                    startDate: notif['start_date'],
                    endDate: notif['end_date'],
                    topic: notif['topic'],
                    occurredTimes: notif['occurred_times'],
                    to: notif['to'],
                    description: notif['description'],
                    recommendedActions: notif['recommended_actions'],
                    severity: notif['severity'],
                    value: notif['value'],
                    accumulated_cost: notif['accumulated_cost'],
                    // accumulated_cost: Math.floor(Math.random() * 20),
                    notification_id: notif.notification_id,
                    acknowledged: notif['acknowledged'],
                    maintenance_records:rawMRs.result.filter(x=>x.notification_id&&x.notification_id===notif.notification_id)
                })
            }
            let floors=sortFloors([...new Set(items.map(x=>x.floor))])
            let types=[...new Set(items.map(x=>x.equipType))]
            let issues=[...new Set(items.map(x=>x.title))]
            let mapData=[]
            for (let findex in floors){
                for (let tindex in types){
                    let found=items.filter(x=>x.floor===floors[parseInt(findex)]&&x.equipType===types[parseInt(tindex)]).length
                    found = found > 0 ? found : "-"
                    mapData.push([parseInt(tindex),parseInt(findex),found])
                }
            }
            this.ecOption= {
                title: {
                    text: 'Issue breakdown',
                },
                tooltip: {
                    position: 'top'
                },
                grid: {
                    height: '75%',
                    top: '7%',
                    left: '20%',
                    backgroundColor: "rgba(0,0,0,0)"
                },
                xAxis: {
                    type: 'category',
                    data: types,
                    splitArea: {
                        show: true
                    },
                    axisLabel: {
                        interval: 0,
                        rotate: 45
                    }
                },
                yAxis: {
                    type: 'category',
                    data: floors,
                    splitArea: {
                        show: true
                    },
                    axisLabel: {
                        interval: 0,
                    }
                },
                visualMap: {
                    min: 0,
                    max: Math.max(...mapData.filter(x=>x[2]!=="-").map(x=>x[2])),
                    calculable: true,
                    orient: 'horizontal',
                    left: 'center',
                    top: '0',
                    textStyle:this.unifiedIsThemeDark ? {color: "rgba(255, 255, 255, 1)" } : null,
                },
                series: [
                    {
                        name: 'Notifications',
                        type: 'heatmap',
                        data: mapData,
                        label: {
                            show: true
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            };
            let sunData=[]
            for (let type of types){
                let topItem={
                    name:type,
                    value:items.filter(x=>x.equipType===type).reduce((sum, x) => sum + x.accumulated_cost, 0),
                    children:[]
                }
                if (topItem.value>0){
                    for (let issue of issues){
                        let subItem={
                            name:issue,
                            value:items.filter(x=>x.equipType===type&&x.title===issue).reduce((sum, x) => sum + x.accumulated_cost, 0),
                        }
                        if(subItem.value>0){
                            topItem.children.push(subItem)
                        }
                    }
                    sunData.push(topItem)
                }

            }
            if(sunData.length>0){
                this.ecOption2={
                    title: {
                        text: 'Cost breakdown',
                    },
                    visualMap: {
                        type: 'continuous',
                        min: 0,
                        max: Math.max(...sunData.map(x=>x.value)),
                        calculable: true,
                        orient: 'horizontal',
                        left: 'center',
                        top: '0',
                        textStyle:this.unifiedIsThemeDark ? {color: "rgba(255, 255, 255, 1)" } : null,

                    },
                    series: {
                        type: 'sunburst',
                        data: sunData,
                        radius: [0, '80%'],
                        label: {
                            rotate: 'radial',
                            formatter : function (params){
                                return  params.name + '\n' + params.value
                            },
                        },
                        emphasis: {
                            focus: 'ancestor'
                        },
                    }
                }
            }
            items.sort((a, b) => {
                if (a.equip === b.equip){
                    return (this.getSeverityScore(a.severity)<this.getSeverityScore(b.severity)) ? 1 : -1
                } else {
                    return (a.equip > b.equip) ? 1 : -1
                }
                }
            )
            this.items=items
            this.loading=false

        },
        getSeverityScore(severity){
            switch(severity) {
                case "critical":
                    return 4
                case "high":
                    return 3
                case "medium":
                    return 2
                case "low":
                    return 1
                default:
                    return 0
            }
        },
        refresh(){
            this.debounce(this.doRefresh,200);
        },
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => callback(), wait);
        },
    },
    async beforeMount(){
        let maxDate=this.$store.state.pointsListStore.pointsList.data_max_date;
        let rangeStart = _.get(this.$route.query, 'rangeStart', null)
        let rangeEnd = _.get(this.$route.query, 'rangeEnd', null)
        if (!!rangeStart) {
            this.dateRange = {start: rangeStart, end: rangeEnd}
        } else if(maxDate){
            this.dateRange={
                start:moment(maxDate).subtract(30, "days").format('YYYY-MM-DD HH:mm:ss'),
                end: moment(maxDate).format('YYYY-MM-DD HH:mm:ss')
            }
        }
    },
}
</script>

<style scoped>

</style>
